import GlobalMetricsModal from './GlobalMetricsModal';

export default GlobalMetricsModal;
